import React from 'react';
import get from 'lodash/get';
import { useSelector, useDispatch } from 'react-redux';
import clsx from 'clsx';

import { getProducts, getPrismic } from 'app/dispatcher/productDispatcher';
import Link from 'app/components/misc/Link';
import { getCurrentCategory } from 'app/selectors/productSelector';
import { RootState } from 'app/reducer';
import analytics from 'app/utils/analytics';

import type { ProductCategory } from 'entity/product/productTypes';

const ProductCategoryList = () => {
  const productCategories: ProductCategory[] = useSelector(
    (state: RootState) => state.product.productCategories,
  );

  const currentCategory = useSelector(getCurrentCategory);
  const categoryId = get(currentCategory, 'id', -1);

  const dispatch = useDispatch();

  return (
    <div className="card">
      {productCategories.map(section => (
        <ul className="mt-8 first:mt-0" key={section.id}>
          <h3 className="text-base font-bold">{section.name}</h3>
          {section.children.map(category => {
            const { slug } = category;

            const isSelected = category.id === categoryId;

            const link = `/reviews?categorySlug=${slug}`;
            const as = `/reviews/${slug}`;

            const handleClick = () => {
              analytics.trackCategoryFilterClick({
                key: slug,
                value: category.name,
              });
              // @ts-ignore until we move getProducts to typescript
              dispatch(getProducts({ categorySlug: slug }));
              dispatch(getPrismic(slug));
            };

            return (
              <li
                key={category.id}
                className={clsx(['mt-4', isSelected && 'text-blue-500'])}
              >
                <Link href={link} as={as} shallow passHref>
                  <a onClick={handleClick} data-testid="product-category-item">
                    {category.name}
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
      ))}
    </div>
  );
};

export default ProductCategoryList;
